import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function CorporateInformation() {
  const { t } = useTranslation();
  const operateItems = t('corporate.operateItems', { returnObjects: true }) || [];
  return (
    <InfoPage
      eyebrow={t('info.company')}
      title={t('corporate.title')}
      subtitle={t('corporate.subtitle')}
    >
      <h2>{t('corporate.whoWeAre')}</h2>
      <p>{t('corporate.whoWeAreCopy')}</p>

      <h2>{t('corporate.whatWeOperate')}</h2>
      <ul>
        {operateItems.map((item) => <li key={item}>{item}</li>)}
      </ul>

      <h2>{t('corporate.whereWeOperate')}</h2>
      <p>{t('corporate.whereWeOperateCopy')}</p>

      <h2>{t('corporate.companyDetails')}</h2>
      <p>
        {t('corporate.companyDetailsCopyBefore')}{' '}
        <a href="mailto:contact@starviewcinema.com">contact@starviewcinema.com</a>
        {t('corporate.companyDetailsCopyAfter')}
      </p>
    </InfoPage>
  );
}
